import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { PostDeleteCompanionRequest } from 'src/sdk_checkin';
import { CheckinBaseClass } from '../../components';
import {
  CheckinDeleteCompanionResultState,
  resetCheckinDeleteCompanionResult,
  selectCheckinDeleteCompanionResultState,
  setCheckinDeleteCompanionResultFromApi,
} from '../../store';
import { DefaultService as Api } from 'src/sdk_checkin/api/default.service';
import { filter, map, pairwise } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class CheckinDeleteCompanionResultStoreService extends CheckinBaseClass {
  private _checkiDeleteCompanionResult$ = this._checkinDeleteCompanionResultStore.pipe(
    select(selectCheckinDeleteCompanionResultState),
    pairwise(),
    filter(([prev, curr]) => prev.isPending === true && curr.isPending === false),
    map(([_, cur]) => cur)
  );

  get success$(): Observable<CheckinDeleteCompanionResultState> {
    return this._checkiDeleteCompanionResult$.pipe(filter((state) => state.isFailure === false));
  }

  get failure$(): Observable<CheckinDeleteCompanionResultState> {
    return this._checkiDeleteCompanionResult$.pipe(filter((state) => state.isFailure === true));
  }

  constructor(private _checkinDeleteCompanionResultStore: Store<CheckinDeleteCompanionResultState>, private api: Api) {
    super();
  }

  override destroy(): void {
    this._checkinDeleteCompanionResultStore.dispatch(resetCheckinDeleteCompanionResult());
  }

  request(parameter: PostDeleteCompanionRequest): void {
    const call = this.api.deleteCompanionPost(parameter);
    this._checkinDeleteCompanionResultStore.dispatch(setCheckinDeleteCompanionResultFromApi({ call }));
  }

  /**
   * CheckinDeleteCompanionResultStoreの中身をクリアする(初期状態に戻す)
   */
  public clearCheckinDeleteCompanionResult() {
    this._checkinDeleteCompanionResultStore.dispatch(resetCheckinDeleteCompanionResult());
  }
}
